import React from 'react';

const Section = ({ children }) => {
  return <div style={{ marginBottom: 55 }}>{children}</div>;
};

export default Section;
